import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "header", "placeholder" ]

    connect() {
        const header = this.headerTarget;
        const placeholder = this.placeholderTarget;
        const stickyClass = "sticky";

        // Set placeholder height to match header height
        const setPlaceholderHeight = () => {
            placeholder.style.height = (`${header.offsetHeight}px`);
            placeholder.classList.add("visually-hidden");
        }

        // Adjust placeholder height on window resize
        window.addEventListener("resize", setPlaceholderHeight);
        setPlaceholderHeight();

        // Add/remove sticky class on scroll
        document.addEventListener("scroll", () => {
            if (window.scrollY > 0) {
                header.classList.add(stickyClass);
                placeholder.classList.remove("visually-hidden");
            } else {
                header.classList.remove(stickyClass);
                placeholder.classList.add("visually-hidden");
            }
        })

        const scrollToHash = (hash) => {
            const element = document.querySelector(hash);
            if (element) {
                const yOffset = -180; // nav height
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        };

        document.querySelectorAll('a[href^="#"]').forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                scrollToHash(link.getAttribute('href'));
            });
        });
    }
}